import ax from '../axios'
import {API_URL} from "../index";

const STORY_QUESTION_URL = API_URL.EDUCATION_MODULE + '/story-question'

const getStoryQuestions = (query: string) => {
    return ax.get(`${STORY_QUESTION_URL}?${query}`)
}

export {
    getStoryQuestions,
}
